import Logo from "../assets/images/logo-modal.png";
import ButtonPrimary from "../SharedComponents/ButtonPrimary";
import ButtonSecondary from "../SharedComponents/ButtonSecondary";
import { ReactComponent as CheckIcon } from "../assets/icons/checkIcon.svg";
import React, { useState, useRef, useEffect, useContext } from "react";
import Score from "../SharedComponents/Score";
import ReactStars from "react-rating-stars-component";
import StarRatings from "react-star-ratings";

import Store from "../Store";
import { postAjax } from "../axiosMethods";
import { saveRating } from "../universalData";
import { useNavigate, useParams } from "react-router-dom";
import Select, { components } from "react-select";

import { ReactComponent as StarIcon } from "../assets/icons/starIcon.svg";
import { ReactComponent as EmptyStarIcon } from "../assets/icons/emptyStarIcon.svg";
import { ReactComponent as WebsiteGray } from "../assets/icons/webGray.svg";
import { ReactComponent as FacebookGray } from "../assets/icons/facebookGray.svg";
import { ReactComponent as YoutubeGray } from "../assets/icons/youtubeGray.svg";
import { ReactComponent as GooglePulsGray } from "../assets/icons/g+Gray.svg";
import { ReactComponent as LinkedInGray } from "../assets/icons/linkedInGray.svg";
import { ReactComponent as TwitterGray } from "../assets/icons/twitterGray.svg";
import { ReactComponent as InstagramGray } from "../assets/icons/instagramGray.svg";
// import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import { useTranslation } from "react-i18next";
import GlobalStates from "../../layouts/GlobalStates";
import { GlobalStateContext } from "./../../layouts/GlobalStates";
import DBButton from "../../component/global/DBButton";
import { scrollIntoView } from "../helperFunctions";

export default function FinalResultModal() {
    const { t, i18n } = useTranslation();

    const { feedbackAppGlobalState } = useContext(GlobalStateContext);
    const [result, setResult] = feedbackAppGlobalState;
    const navigate = useNavigate();

    const { id } = useParams();
    const [page, setPage] = useState(1);
    const [msg, setMsg] = useState("");
    const [progress, setProgress] = useState(0);
    const [color, setColor] = useState();
    const [phoneNum, setPhoneNum] = useState();
    const [dynamicFieldsErrCheck, setDynamicFieldsErrCheck] = useState(false);
    const [finalRating, setFinalRating] = useState([]);
    const [rulesAccepted, setRulesAccepted] = useState(false);

    return (
        <div className="final-form">
            <div className="form-content">
                {/* <div className="modal-logo">
                    <img src={Logo} alt="logo" />
                    {!result.username && (
                        <button className="close-btn" onClick={close}>
                            &times;
                        </button>
                    )}
                </div> */}

                <div className="modal-content-2">
                    <div className="title-container">
                        <div className="title" id="final-form-title-2">
                            {t("successful.feedback")}
                        </div>
                        <div className="checked">
                            <CheckIcon />
                        </div>
                    </div>
                    <p>
                        {t("successful.message").replace("*", "")}

                        <div class="gray-message">
                            {window.innerWidth > 1024 ? (
                                <>
                                    {t("successful.hint").split("*")[0]}
                                    <a href="https://panel.dideban24.net">
                                        panel.dideban24.net
                                    </a>
                                    {t("successful.hint").split("*")[1]}
                                </>
                            ) : (
                                t("successful.hint.pwa")
                            )}
                        </div>
                    </p>
                    {/* <div className="user-score">
                        <div className="score-card">
                            <div className="title-container">
                                <div className="title"> {t("form.avg")} </div>
                            </div>
                            <div className="card-detail">
                                <div className="rating-stars">
                                    <StarRatings
                                        starRatedColor="rgb(254, 183, 48)"
                                        starEmptyColor="#ccc"
                                        rating={finalRating[0]}
                                        starDimension="40px"
                                        starSpacing="-5px"
                                        svgIconPath="M 24.49994659423828 28.95012855529785 C 24.3575267791748 28.95013999938965 24.21438789367676 28.92934989929199 24.07449722290039 28.88831901550293 L 17.04545783996582 26.82704925537109 C 16.81686782836914 26.76001930236816 16.58017730712891 26.72602844238281 16.34195709228516 26.72602844238281 C 16.10373687744141 26.72602844238281 15.86704730987549 26.76001930236816 15.63845729827881 26.82705879211426 L 8.609416961669922 28.88831901550293 C 8.46955680847168 28.9293384552002 8.326407432556152 28.95012855529785 8.183937072753906 28.95012855529785 C 7.37572717666626 28.95012855529785 6.704487323760986 28.29068946838379 6.687637329101563 27.4801197052002 L 6.542447090148926 20.49673843383789 C 6.531887054443359 19.98868942260742 6.36951732635498 19.50203895568848 6.072886943817139 19.08940887451172 L 1.987167119979858 13.40614891052246 C 1.706327080726624 13.01549911499023 1.629837036132813 12.52879905700684 1.777297139167786 12.07082939147949 C 1.924757122993469 11.61286926269531 2.270867109298706 11.26223945617676 2.726886987686157 11.10884952545166 L 9.559877395629883 8.810439109802246 C 10.02445697784424 8.654169082641602 10.4296875 8.367519378662109 10.73174667358398 7.981479167938232 L 15.16060733795166 2.321199178695679 C 15.44685745239258 1.955369234085083 15.87743663787842 1.745549201965332 16.34195709228516 1.745549201965332 C 16.80647659301758 1.745549201965332 17.23705673217773 1.955369234085083 17.52330780029297 2.321199178695679 L 21.95216751098633 7.981459140777588 C 22.25423622131348 8.367519378662109 22.65946769714355 8.654169082641602 23.12403678894043 8.810439109802246 L 29.9570369720459 11.10884952545166 C 30.41304779052734 11.26223945617676 30.75915718078613 11.61286926269531 30.9066162109375 12.07082939147949 C 31.0540771484375 12.52879905700684 30.97758674621582 13.01549911499023 30.69674682617188 13.40614891052246 L 26.61103630065918 19.08940887451172 C 26.31441688537598 19.50200843811035 26.15203666687012 19.98864936828613 26.14146614074707 20.49672889709473 L 25.99627685546875 27.48012924194336 C 25.97942733764648 28.2906494140625 25.30817794799805 28.95008850097656 24.49994659423828 28.95012855529785 Z"
                                    />
                                </div>
                                <div>
                                    {Math.round(finalRating[0] * 100) / 100}{" "}
                                    {t("form.score.splitter")} 5
                                </div>
                            </div>
                        </div>
                        <div className="score-card">
                            <div className="title-container">
                                <div className="title">
                                    {t("form.your.score")}
                                </div>
                            </div>
                            <div className="card-detail">
                                <Score size="small" score={5} title="false" />
                                <div>{finalRating[3]}</div>
                            </div>
                        </div>
                    </div> */}
                    <div className="social-tilte">{t("follow.us")}</div>
                    <div className="social-media">
                        <button>
                            <WebsiteGray />
                        </button>
                        <button>
                            <LinkedInGray />
                        </button>
                        <button>
                            <GooglePulsGray />
                        </button>
                        <button>
                            <YoutubeGray />
                        </button>
                        <button>
                            <InstagramGray />
                        </button>
                        <button>
                            <TwitterGray />
                        </button>
                        <button>
                            <FacebookGray />
                        </button>
                    </div>
                    <DBButton
                        outlined
                        caption={t("share.dideban")}
                        onClick={() => {
                            navigate("/feedback/share-product/" + id);
                            setTimeout((_) => {
                                window.scrollTo(0, 0);
                            }, 100);
                        }}
                    />
                    {/* <DBButton
                        outlined
                        caption={t("send.feedback")}
                        onClick={() => {
                            navigate("/feedback/more/" + id);
                            setTimeout((_) => {
                                window.scrollTo(0, 0);
                            }, 100);
                        }}
                    /> */}
                    <DBButton
                        outlined
                        caption={t("go.to.home")}
                        onClick={() => {
                            navigate("/feedback/" + id);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
